<div class="about-video-container">
    <video controls loop [muted]="true" poster="../../../../assets/image/home-page/video-preload-crop.png">
        <source src="/assets/video/KPC_Video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
    </video>
</div>